 <!--
# -----------------------------------------------------------------------------
# Component: PolicyListing.vue
# Author: PST
# Created Date: 02/April/2019
# Comments: Manage Policy Listing where TranRel=false
# -----------------------------------------------------------------------------
-->
<template>
  <page :load="loadInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap align-end>
        <v-flex xs10>
          <card-menu :items="cardMenu" @cardReturn="visibleControl" subMenu></card-menu>
        </v-flex>
        <v-flex xs2>
          <v-container fluid class="pa-0" align="right">
            <span align="right">
              <div class="text-center">
                <v-tooltip top v-if="checkAccess([permissionKeys.perm_011020])">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="cyan" v-on="on" @click.native="doButtons('copy')"
                      ><v-icon dark>mdi-content-copy</v-icon></v-btn
                    >
                  </template>
                  <span>Copy Policy</span>
                </v-tooltip>
                <v-tooltip top v-if="checkAccess([permissionKeys.perm_011025])">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="primary" v-on="on" @click.native="doButtons('amend')"
                      ><v-icon dark>mdi-pencil-box-outline</v-icon></v-btn
                    >
                  </template>
                  <span>Amend Policy</span>
                </v-tooltip>
                <v-tooltip top v-if="checkAccess([permissionKeys.perm_011030])">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="error" v-on="on" @click.native="doButtons('remove')"><v-icon dark>mdi-delete</v-icon></v-btn>
                  </template>
                  <span>Delete Policy</span>
                </v-tooltip>
              </div>
            </span>
          </v-container>
        </v-flex>
      </v-layout>
      <!-- <message :messages="messages"></message> -->
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels v-model="filterPanels" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    Filters for {{ listMode }}
                    <span class="caption grey--text font-weight-light">
                      {{ defaultFilter.filterName !== undefined ? ' (' + defaultFilter.filterName + ')' : '' }}</span
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg4 xs6>
                            <v-autocomplete
                              :items="params.mainClasses"
                              v-model="filters.mainClasses"
                              :label="filtersLabel.mainClasses"
                              item-text="label"
                              item-value="value"
                              data-vv-name="mainClasses"
                              :data-vv-as="filtersLabel.mainClasses"
                              :error-messages="errors.collect('mainClasses')"
                              @change="valMainClasses"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex lg8 xs6> </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.polNo"
                              :label="filtersLabel.polNo"
                              :error-messages="errors.collect('polNo')"
                              data-vv-name="polNo"
                              :data-vv-as="filtersLabel.polNo"
                              v-validate="'entry|max:16|min_char:3'"
                              :maxlength="16"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.moCmpNo"
                              :label="filtersLabel.moCmpNo"
                              :error-messages="errors.collect('moCmpNo')"
                              data-vv-name="moCmpNo"
                              :data-vv-as="filtersLabel.moCmpNo"
                              v-validate="'entry|max:16'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.insdName1"
                              :label="filtersLabel.insdName1"
                              :error-messages="errors.collect('insdName1')"
                              data-vv-name="insdName1"
                              :data-vv-as="filtersLabel.insdName1"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-autocomplete
                              :items="polTypeList"
                              v-model="filters.polType"
                              :label="filtersLabel.polType"
                              item-text="label"
                              item-value="value"
                              data-vv-name="polType"
                              :data-vv-as="filtersLabel.polType"
                              :error-messages="errors.collect('polType')"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.cnNo"
                              :label="filtersLabel.cnNo"
                              :error-messages="errors.collect('cnNo')"
                              data-vv-name="cnNo"
                              :data-vv-as="filtersLabel.cnNo"
                              v-validate="'entry|max:16'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <cal-picker
                              v-model="filters.comDate"
                              :label="filtersLabel.comDate"
                              :error-messages="errors.collect('comDate')"
                              data-vv-name="comDate"
                              :data-vv-as="filtersLabel.comDate"
                            ></cal-picker>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <cal-picker
                              v-model="filters.expDate"
                              :label="filtersLabel.expDate"
                              :error-messages="errors.collect('expDate')"
                              data-vv-name="expDate"
                              :data-vv-as="filtersLabel.expDate"
                            ></cal-picker>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <cal-picker
                              v-model="filters.tranDate"
                              :label="filtersLabel.tranDate"
                              :error-messages="errors.collect('tranDate')"
                              data-vv-name="tranDate"
                              :data-vv-as="filtersLabel.tranDate"
                            ></cal-picker>
                          </v-flex>
                        </v-layout>
                        <transition name="slide-x-transition" mode="out-in">
                          <v-layout row wrap v-if="showDetailFilters">
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.insdRefNo"
                                :label="filtersLabel.insdRefNo"
                                :error-messages="errors.collect('insdRefNo')"
                                data-vv-name="insdRefNo"
                                :data-vv-as="filtersLabel.insdRefNo"
                                v-validate="'entry|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.icNo"
                                :label="filtersLabel.icNo"
                                :error-messages="errors.collect('icNo')"
                                data-vv-name="icNo"
                                :data-vv-as="filtersLabel.icNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.riCo"
                                :label="filtersLabel.riCo"
                                :error-messages="errors.collect('riCo')"
                                data-vv-name="riCo"
                                :data-vv-as="filtersLabel.riCo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.acctNo1"
                                :label="filtersLabel.acctNo1"
                                :error-messages="errors.collect('acctNo1')"
                                data-vv-name="acctNo1"
                                :data-vv-as="filtersLabel.acctNo1"
                                v-validate="'entry|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.cedPolNo"
                                :label="filtersLabel.cedPolNo"
                                :error-messages="errors.collect('cedPolNo')"
                                data-vv-name="cedPolNo"
                                :data-vv-as="filtersLabel.cedPolNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.cedCesNo"
                                :label="filtersLabel.cedCesNo"
                                :error-messages="errors.collect('cedCesNo')"
                                data-vv-name="cedCesNo"
                                :data-vv-as="filtersLabel.cedCesNo"
                                v-validate="'entry|max:40'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.brkSlipNo"
                                :label="filtersLabel.brkSlipNo"
                                :error-messages="errors.collect('brkSlipNo')"
                                data-vv-name="brkSlipNo"
                                :data-vv-as="filtersLabel.brkSlipNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.brkTranRef"
                                :label="filtersLabel.brkTranRef"
                                :error-messages="errors.collect('brkTranRef')"
                                data-vv-name="brkTranRef"
                                :data-vv-as="filtersLabel.brkTranRef"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showBusCls == true && getDetTab === 'Risk Details'">
                              <v-autocomplete
                                :items="buscls"
                                v-model="filters.busCls"
                                :label="filtersLabel.busCls"
                                item-text="label"
                                item-value="value"
                                :error-messages="errors.collect('filters.busCls')"
                                data-vv-name="busCls"
                                :data-vv-as="filtersLabel.busCls"
                                clearable
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVesNo">
                              <v-text-field
                                v-model="filters.vesNo"
                                :label="filtersLabel.vesNo"
                                :error-messages="errors.collect('vesNo')"
                                data-vv-name="vesNo"
                                :data-vv-as="filtersLabel.vesNo"
                                v-validate="'entry|max:7'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVesName">
                              <v-text-field
                                v-model="filters.vesName"
                                :label="filtersLabel.vesName"
                                :error-messages="errors.collect('vesName')"
                                data-vv-name="vesName"
                                :data-vv-as="filtersLabel.vesName"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVesName"> </v-flex>
                            <v-flex lg4 xs6 v-if="showVoyNo">
                              <v-text-field
                                v-model="filters.voyNo"
                                :label="filtersLabel.voyNo"
                                :error-messages="errors.collect('voyNo')"
                                data-vv-name="voyNo"
                                :data-vv-as="filtersLabel.voyNo"
                                v-validate="'entry|max:6'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVoyDesc">
                              <v-text-field
                                v-model="filters.voyDesc"
                                :label="filtersLabel.voyDesc"
                                :error-messages="errors.collect('voyDesc')"
                                data-vv-name="voyDesc"
                                :data-vv-as="filtersLabel.voyDesc"
                                v-validate="'entry|max:120'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVoyDesc"> </v-flex>
                            <v-flex lg4 xs6 v-if="showRiskLoc">
                              <v-text-field
                                v-model="filters.riskLoc"
                                :label="filtersLabel.riskLoc"
                                :error-messages="errors.collect('riskLoc')"
                                data-vv-name="riskLoc"
                                :data-vv-as="filtersLabel.riskLoc"
                                v-validate="'entry|max:40'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showRiskLoc"> </v-flex>
                            <v-flex lg4 xs6 v-if="showRiskLoc"> </v-flex>
                            <!-- <v-flex lg4 xs6 v-if="showContrt">
                              <v-text-field
                                v-model="filters.contrt"
                                :label="filtersLabel.contrt"
                                :error-messages="errors.collect('contrt')"
                                data-vv-name="contrt"
                                :data-vv-as="filtersLabel.contrt"
                                v-validate="'entry|max:8'"
                              ></v-text-field>
                            </v-flex> -->
                            <v-flex lg4 xs6 v-if="showContrt"> </v-flex>
                            <v-flex lg4 xs6 v-if="showContrt"> </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.vehRegNo"
                                :label="filtersLabel.vehRegNo"
                                :error-messages="errors.collect('vehRegNo')"
                                data-vv-name="vehRegNo"
                                :data-vv-as="filtersLabel.vehRegNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.ownName"
                                :label="filtersLabel.ownName"
                                :error-messages="errors.collect('ownName')"
                                data-vv-name="ownName"
                                :data-vv-as="filtersLabel.ownName"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor"> </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.engNo"
                                :label="filtersLabel.engNo"
                                :error-messages="errors.collect('engNo')"
                                data-vv-name="engNo"
                                :data-vv-as="filtersLabel.engNo"
                                v-validate="'entry|max:30'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.chasNo"
                                :label="filtersLabel.chasNo"
                                :error-messages="errors.collect('chasNo')"
                                data-vv-name="chasNo"
                                :data-vv-as="filtersLabel.chasNo"
                                v-validate="'entry|max:30'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.trailerRegNo"
                                :label="filtersLabel.trailerRegNo"
                                :error-messages="errors.collect('trailerRegNo')"
                                data-vv-name="trailerRegNo"
                                :data-vv-as="filtersLabel.trailerRegNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </transition>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn text @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                      <v-btn text @click.native="showDetailFilters = false" v-if="showDetailFilters">Show Less Filters</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout>
        <!-- Policy/Risk Details Tabs Style -->
        <v-flex xs12>
          <v-card>
            <!-- Tabs in Policy list -->
            <v-tabs left v-model="tab">
              <!-- <v-tab v-for="(detailTab, x) in detailTabs" :key="x" @click="doColumn(detailTab, columns)" :disabled="doDisabledTab(detailTab)">{{ -->
              <v-tab v-for="(detailTab, x) in detailTabs" :key="x" @click="doColumn(detailTab)" :disabled="doDisabledTab(detailTab)">{{
                detailTab
              }}</v-tab>
              <v-spacer></v-spacer>
              <v-btn class="mr-2 mt-2" v-if="checkAccess([permissionKeys.perm_011045])" color="primary" @click.native="doCreatePolicy">
                <span>{{ labels.createPolicy }}</span>
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>
              <v-menu
                v-if="checkAccess([permissionKeys.perm_011050])"
                offset-x
                :nudge-left="370"
                :close-on-content-click="false"
                :min-width="300"
                :max-height="400"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" class="white--text mr-2 mt-2" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <v-card v-if="tab === 0">
                  <v-card-text>
                    <template v-if="policyColumns.length > 0">
                      <v-checkbox
                        v-for="column in policyColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolicyColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                </v-card>
                <v-card v-else>
                  <v-card-text v-if="filters.mainClasses === 'Cargo'">
                    <template v-if="polCargoRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polCargoRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolCargoRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Fire'">
                    <template v-if="polFireRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polFireRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolFireRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Hull'">
                    <template v-if="polHullRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polHullRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolHullRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Medical'">
                    <template v-if="polMedRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polMedRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolMedRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Personal Accident'">
                    <template v-if="polPaRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polPaRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolPaRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Miscellaneous'">
                    <template v-if="polMiscRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polMiscRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolMiscRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Motor'">
                    <template v-if="polMotorRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polMotorRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolMotorRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'All Classes'">
                    <template v-if="allClassRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in allClassRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedAllClassRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                </v-card>
              </v-menu>
              <v-btn class="mr-2 mt-2" v-if="checkAccess([permissionKeys.perm_011095])" color="info" @click.native="doExportFilters">
                <span>{{ labels.exportList }}</span>
                <v-icon right dark>mdi-file-excel</v-icon>
              </v-btn>
            </v-tabs>
            <v-tabs-items v-model="tab" touchless>
              <v-tab-item :key="1">
                <v-flex xs12 class="mt-2">
                  <v-data-table
                    :headers="listPolicyHeaders"
                    :items="items"
                    :options.sync="paginationPolHeader"
                    :server-items-length="totalItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedPolicyColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row) && checkAccess([permissionKeys.perm_011060])"
                            :review="canReview(row) && checkAccess([permissionKeys.perm_011055])"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Cargo'">
                  <v-data-table
                    :headers="listPolCargoRiskHeaders"
                    :items="riskItems"
                    :options.sync="pagination"
                    :server-items-length="totalCargoItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedPolCargoRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row)"
                            :review="canReview(row)"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Fire'">
                  <v-data-table
                    :headers="listPolFireRiskHeaders"
                    :items="riskItems"
                    :options.sync="pagination"
                    :server-items-length="totalFireItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedPolFireRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row)"
                            :review="canReview(row)"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Hull'">
                  <v-data-table
                    :headers="listPolHullRiskHeaders"
                    :items="riskItems"
                    :options.sync="pagination"
                    :server-items-length="totalHullItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedPolHullRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row)"
                            :review="canReview(row)"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Medical'">
                  <v-data-table
                    :headers="listPolMedRiskHeaders"
                    :items="riskItems"
                    :options.sync="pagination"
                    :server-items-length="totalMedItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedPolMedRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row)"
                            :review="canReview(row)"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Personal Accident'">
                  <v-data-table
                    :headers="listPolPaRiskHeaders"
                    :items="riskItems"
                    :options.sync="pagination"
                    :server-items-length="totalPaItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedPolPaRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row)"
                            :review="canReview(row)"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Miscellaneous'">
                  <v-data-table
                    :headers="listPolMiscRiskHeaders"
                    :items="riskItems"
                    :options.sync="pagination"
                    :server-items-length="totalMiscItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedPolMiscRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row)"
                            :review="canReview(row)"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Motor'">
                  <v-data-table
                    :headers="listPolMotorRiskHeaders"
                    :items="riskItems"
                    :options.sync="pagination"
                    :server-items-length="totalMotorItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedPolMotorRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row) && checkAccess([permissionKeys.perm_011060])"
                            :review="canReview(row) && checkAccess([permissionKeys.perm_002])"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'All Classes'">
                  <v-data-table
                    :headers="listAllClassRiskHeaders"
                    :items="riskItems"
                    :options.sync="pagination"
                    :server-items-length="totalAllClassItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedAllClassRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            :query="canQuery(row)"
                            :review="canReview(row)"
                            :create="canCreate(row)"
                            :copy="canCopy(row)"
                            :amend="canAmend(row)"
                            :remove="canRemove(row)"
                            @query="doQuery(row)"
                            @review="doReview(row)"
                            @create="doCreate(row)"
                            @copy="doCopy(row)"
                            @amend="doAmend(row)"
                            @remove="doRemove(row)"
                            :loading="loading"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <warning v-model="warnRenewPolicy" @ok="doAcceptRenewPolicy" @cancel="doCancelRenewPolicy">{{ warnRenewPolicyMsg }}</warning>

    <v-dialog v-model="copyPolicy" width="900px" persistent eager>
      <CopyPolicy ref="copyPolicy" @close="doCloseCopyPolicy" :policyData="policyData"></CopyPolicy>
    </v-dialog>

    <v-dialog v-model="endorsePolicy" width="300px" persistent eager>
      <EndorsePolicy ref="endorsePolicy" @close="doCloseEndorsePolicy" :policyData="policyData"></EndorsePolicy>
    </v-dialog>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterList" width="800px" persistent>
      <SearchFilter
        :boolRefresh="showFilterList"
        :filterTitle="'Saved Filters - Policy Listing'"
        @close="showFilterList = false"
        :filterCode="filterCode"
        @applyDefaultFilter="applyDefaultFilter"
      ></SearchFilter>
    </v-dialog>

    <v-dialog v-model="saveFilter" width="800px" persistent>
      <UpdateSearchFilter
        :boolRefresh="saveFilter"
        :dialogTitle="'Filter'"
        :actionName="'new'"
        :filters="filters"
        @close="saveFilter = false"
        @reloadList="reloadList"
        :filterCode="filterCode"
        @applyDefaultFilter="applyDefaultFilter"
      ></UpdateSearchFilter>
    </v-dialog>

    <warning v-model="exportList.promptFilterWarning" :label="exportList.promptFilterWarningMsg" @ok="exportList.cfmExportUwList = true"/>
    <columns-selector v-if="exportList.cfmExportUwList" :titleTabDet="this.getDetTab" :columns="exportList.selectorColumns" v-model="exportList.cfmExportUwList" @export="doExportList"/>
  </page>
</template>

<script>
import clone from 'clone'
import { listPolicyMixin } from '../listPolicyMixin'
import { removeTime, formatDisplayDateTime2 } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatYesNo } from '@/utils/boolean'
import {
  POLICY_NEW_MODE,
  POLICY_RESET,
  POLICY_RENEWAL_MODE,
  POLICY_REVIEW_MODE,
  POLICY_ENDORSEMENT_MODE,
  POLICY_CANCELLATION_MODE
} from '@/store/types'
import { mapGetters } from 'vuex'
import { permissionKeys } from '@/mixins/global/permissionKey'
import CopyPolicy from './CopyPolicy'
import EndorsePolicy from './EndorsePolicy'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filterCode: 'POL',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      defaultFilter: {},
      paginationPolHeader: {
        sortDesc: [true],
        sortBy: ['tranDate'],
        page: 1,
        itemsPerPage: 5
      },
      cardMenu: [
        { text: 'Policy', icon: 'mdi-file-document', name: '', params: { tab: 'policy' }, access: '', default: true },
        { text: 'Endorsement', icon: 'mdi-file-multiple', name: '', params: { tab: 'endorse' }, access: '' },
        { text: 'Renewal', icon: 'mdi-refresh', name: '', params: { tab: 'renew' }, access: '' }
      ],
      listMode: 'Policy',
      visibleTab: {},
      tab: undefined,
      policyTab: ['Policy Details'],
      detailTabs: ['Policy Details', 'Risk Details'],
      policyColumns: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Ren', value: 'renCnt' },
        { text: 'Endt', value: 'endtCnt' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Pol Type', value: 'polType' },
        { text: 'Com Date', value: 'comDate' },
        { text: 'Exp Date', value: 'expDate' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Stat', value: 'polStat' },
        { text: 'Type', value: 'tranType' },
        { text: 'Rel', value: 'tranRel' },
        { text: 'Bill Acct', value: 'acctNo1' },
        { text: 'Master Pol No. / OC', value: 'moCmpNo' },
        { text: 'Insured Ref No.', value: 'insdRefNo' },
        { text: 'Ced Pol No.', value: 'cedPolNo' },
        { text: 'Ced Ces ', value: 'cedCesNo' },
        { text: 'Broker Slip No.', value: 'brkSlipNo' },
        { text: 'Broker Tran Ref', value: 'brkTranRef' }
      ],
      selectedPolicyColumns: [
        'polNo',
        'renCnt',
        'endtCnt',
        'insdName1',
        'polType',
        'comDate',
        'expDate',
        'tranDate',
        'polStat',
        'tranType',
        'tranRel'
      ],
      // selectedPolicyColumns: ['polNo', 'renCnt', 'endtCnt', 'insdName1', 'polType', 'comDate', 'expDate', 'tranDate', 'polStat', 'tranType', 'tranRel', 'acctNo1'],
      polCargoRiskColumns: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Ren', value: 'renCnt' },
        { text: 'Endt', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No.', value: 'riskNo' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Vessel Ref ', value: 'vesNo' },
        { text: 'Vessel Name', value: 'vesName' },
        { text: 'Voyage Ref ', value: 'voyNo' },
        { text: 'Voyage Desc ', value: 'voyDesc' }
      ],
      selectedPolCargoRiskColumns: [
        'polNo',
        'renCnt',
        'endtCnt',
        'riskGrpNo',
        'riskNo',
        'busCls',
        'insdName1',
        'tranDate',
        'vesNo',
        'vesName',
        'voyNo',
        'voyDesc'
      ],
      polFireRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Risk Location 1', value: 'riskLoc' }
      ],
      selectedPolFireRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'busCls', 'insdName1', 'tranDate', 'riskLoc'],
      polHullRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Vessel Ref ', value: 'vesNo' },
        { text: 'Vessel Name', value: 'vesName' }
      ],
      selectedPolHullRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'busCls', 'insdName1', 'tranDate', 'vesNo', 'vesName'],
      polMedRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'NRIC No. ', value: 'icNo' }
      ],
      selectedPolMedRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'busCls', 'insdName1', 'tranDate', 'icNo'],
      polPaRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'NRIC No. ', value: 'icNo' }
      ],
      selectedPolPaRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'busCls', 'insdName1', 'tranDate', 'icNo'],
      polMiscRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' }
        // { text: 'Contract No. ', value: 'contrt' }
      ],
      // selectedPolMiscRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'busCls', 'insdName1', 'tranDate', 'contrt'],
      selectedPolMiscRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'busCls', 'insdName1', 'tranDate'],
      allClassRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' }
      ],
      selectedAllClassRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'busCls', 'insdName1', 'tranDate'],
      polMotorRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Veh Reg No. ', value: 'vehRegNo' },
        { text: 'Engine No. ', value: 'engNo' },
        { text: 'Chassis No. ', value: 'chasNo' },
        { text: 'Trailer No. ', value: 'trailerRegNo' },
        { text: 'Owner', value: 'ownName' }
      ],
      selectedPolMotorRiskColumns: [
        'polNo',
        'renCnt',
        'endtCnt',
        'riskGrpNo',
        'riskNo',
        'busCls',
        'insdName1',
        'tranDate',
        'vehRegNo',
        'engNo',
        'chasNo',
        'trailerRegNo',
        'ownName'
      ],
      params: {
        mainClasses: [
          { label: 'All Classes', value: 'All Classes' },
          { label: 'Cargo', value: 'Cargo' },
          { label: 'Fire', value: 'Fire' },
          { label: 'Hull', value: 'Hull' },
          // { label: 'Medical', value: 'Medical' },
          { label: 'Miscellaneous', value: 'Miscellaneous' },
          { label: 'Motor', value: 'Motor' }
          // { label: 'Personal Accident', value: 'Personal Accident' }
        ],
        review: [
          { label: 'Review', value: 'Review' },
          { label: 'Endorse', value: 'Endorse' },
          { label: 'Renew', value: 'Renew' },
          { label: 'Query', value: 'Query' }
        ]
      },
      filters: {
        mainClasses: null,
        review: null,
        polNo: null,
        moCmpNo: null,
        insdName1: null,
        comDate: null,
        expDate: null,
        tranDate: null,
        insdRefNo: null,
        acctNo1: null,
        cedPolNo: null,
        cedCesNo: null,
        brkSlipNo: null,
        brkTranRef: null,
        vesNo: null,
        vesName: null,
        voyNo: null,
        voyDesc: null,
        riskLoc: null,
        icNo: null,
        // contrt: null,
        vehRegNo: null,
        ownName: null,
        engNo: null,
        chasNo: null,
        trailerRegNo: null,
        riCo: null,
        polType: null,
        cnNo: null,
        busCls: null
      },
      filtersLabel: {
        mainClasses: 'Main Classes',
        review: 'Review',
        polNo: 'Policy No. ',
        moCmpNo: 'Open Cover / Master Policy No.',
        insdName1: 'Insured Name',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        tranDate: 'Transaction Date',
        insdRefNo: 'Insured Reference',
        acctNo1: 'Billing Account No.',
        cedPolNo: 'Cedant Policy No. ',
        cedCesNo: 'Cedant Cession No. ',
        brkSlipNo: 'Broker Slip No. ',
        brkTranRef: 'Broker Transaction Reference',
        vesNo: 'Vessel Reference',
        vesName: 'Vessel Name',
        voyNo: 'Voyage Reference',
        voyDesc: 'Voyage Description',
        riskLoc: 'Risk Location 1',
        icNo: 'Insured NRIC No. ',
        // contrt: 'Contract No. ',
        vehRegNo: 'Vehicle Registration No. ',
        ownName: 'Name of Owner',
        engNo: 'Engine No. ',
        chasNo: 'Chassis No. ',
        trailerRegNo: 'Trailer No. ',
        riCo: 'Reinsurer Reference',
        polType: 'Policy Type',
        cnNo: 'Cover Note No.',
        busCls: 'Business Class'
      },
      labels: {
        copyPolicy: 'Copy',
        amendPolicy: 'Amend ',
        deletePolicy: 'Delete',
        createPolicy: 'New Policy',
        exportList: 'Export List'
      },
      showDetailFilters: false,
      // activeTab: 'Policy',
      policyTabs: {
        depressed: '',
        name: 'Policy Details'
      },
      riskTabs: {
        depressed: 'depressed',
        name: 'Risk Details'
      },
      showRisk: false,
      showPolicyTabs: true,
      showBusCls: false,
      showVesNo: false,
      showVesName: false,
      showVoyNo: false,
      showVoyDesc: false,
      showRiskLoc: false,
      showIcNo: true,
      showContrt: false,
      showMotor: false,
      loadRisk: true,
      policyList: [],
      riskList: [],
      polTypeList: [],
      buscls: [],
      selectedPage: 0,
      showRiskTabs: false,
      permissionKeys: permissionKeys,
      copyPolicy: false,
      policyData: undefined,
      endorsePolicy: false,
      processing: false,
      showErrorDialog: false,
      acceptRenewPolicy: false,
      warnRenewPolicy: false,
      warnRenewPolicyMsg: undefined,
      initialLoad: true,
      getDetTab: undefined,
      pagination: {
        sortDesc: [true],
        sortBy: ['tranDate'],
        page: 1
      },
      isAfterDefFilter: false,
      riskItems: [],
      filterPanels: [],
      exportList: {
        selectorColumns: [],
        promptFilterWarning: false,
        cfmExportUwList: false,
        promptFilterWarningMsg: 'Do you want to proceed without any filtering?'
      }
    }
  },
  watch: {
    'paginationPolHeader': function (value) {
      if (this.isAfterDefFilter === true) {
        this.fetchData(false)
      }
    },
    // tab: function (value) {
    //   if (value === 0) {
    //     this.doColumn('Policy Details', this.columns)
    //   }
    // },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('buscls')
      this.getDetTab = this.detailTabs[0]
      this.doAssignSelectorColumns()
    },
    visibleControl(data) {
      if (typeof data !== 'undefined') {
        this.visibleTab = { ...data }
        if (this.initialLoad === false) {
          this.doButtons(this.visibleTab.tab)
        }
      } else {
        this.visibleTab = {}
      }
    },
    async loadInit() {
      this.cardMenu = []
      if (this.checkAccess([permissionKeys.perm_011005]) === true) {
        this.cardMenu.push({ text: 'Policy', icon: 'mdi-file-document', name: '', params: { tab: 'policy' }, access: '', default: true })
      }
      if (this.checkAccess([permissionKeys.perm_011010]) === true) {
        this.cardMenu.push({ text: 'Endorsement', icon: 'mdi-file-multiple', name: '', params: { tab: 'endorse' }, access: '' })
      }
      if (this.checkAccess([permissionKeys.perm_011015]) === true) {
        this.cardMenu.push({ text: 'Renewal', icon: 'mdi-refresh', name: '', params: { tab: 'renew' }, access: '' })
      }
      await Promise.all([this.$store.dispatch('searchFilterInit')])
      this.getDefaultFilter()
      // AR: OS-660 Added to check record lock 2021-01-21
      this.initCommonUtilMenu()
    },
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.fetchData()
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      this.showFilterList = false
      if (this.defaultFilter.filters !== undefined) {
        this.filters = this.defaultFilter.filters
      }
      this.fetchData(false)
    },
    async getDefaultFilter() {
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.filters = this.defaultFilter.filters
              this.valMainClasses()
            }
            this.fetchData(true)
          } else {
            this.fetchData(true)
          }
          this.isAfterDefFilter = true
        } catch (err) {
          this.loading = false
        }
      }
    },
    async fetchData(options) {
      // Sanitize date filters
      let massageFilters = clone(this.filters)
      if (massageFilters.comDate) {
        massageFilters.comDate = formatDisplayDateTime2(removeTime(massageFilters.comDate))
      }
      if (massageFilters.expDate) {
        massageFilters.expDate = formatDisplayDateTime2(removeTime(massageFilters.expDate))
      }
      if (massageFilters.tranDate) {
        massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
      }
      if (this.showPolicyTabs) {
        if (this.apiUrl) {
          try {
            this.loading = true
            this.showRiskTabs = false
            const { page, itemsPerPage } = this.paginationPolHeader
            const expand = {
              page: page - 1,
              size: itemsPerPage
            }
            const result = await this.$http.get(
              filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.paginationPolHeader.sortBy, this.paginationPolHeader.sortDesc)
            )

            if (result.data) {
              this.totalItems = result.data.totalElements
              const { data } = result.data
              if (data) {
                // Format the data here
                this.items = []
                data.map((policy) => {
                  const convertPolicy = {
                    polNo: policy.polNo,
                    renCnt: policy.renCnt,
                    endtCnt: policy.endtCnt,
                    insdName1: policy.insdName1.trim() + ' ' + (policy.insdName2 === undefined ? '' : policy.insdName2.trim()) + ' ' + (policy.insdName3 === undefined ? '' : policy.insdName3.trim()),
                    polType: policy.polType,
                    comDate: this.formatDate(policy.comDate),
                    expDate: this.formatDate(policy.expDate),
                    tranDate: this.formatDate(policy.tranDate),
                    polStat: policy.polStat,
                    tranType: policy.tranType,
                    tranRel: formatYesNo(policy.tranRel),
                    acctNo1: policy.acctNo1,
                    moCmpNo: policy.moCmpNo,
                    insdRefNo: policy.insdRefNo,
                    cedPolNo: policy.cedPolNo,
                    cedCesNo: policy.cedCesNo,
                    brkSlipNo: policy.brkSlipNo,
                    brkTranRef: policy.brkTranRef,
                    billType: policy.billType,
                    renPolNo: policy.renPolNo,
                    entRILater: formatYesNo(policy.entRILater)
                  }
                  this.items.push(convertPolicy)
                })
                this.showRiskTabs = true
              } else {
                this.items = []
              }
              this.policyList = this.items
            }
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
            this.loading = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      } else {
        if (this.filters.mainClasses === 'Cargo') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalCargoItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.riskItems = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      busCls: risk.busCls,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      vesNo: risk.vesNo,
                      vesName: risk.vesName,
                      voyNo: risk.voyNo,
                      voyDesc: risk.voyDesc
                    }
                    this.riskItems.push(convertRisk)
                    this.riskList = this.riskItems
                  })
                } else {
                  this.riskItems = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Fire') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalFireItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.riskItems = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      busCls: risk.busCls,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      riskLoc: risk.riskLoc
                    }
                    this.riskItems.push(convertRisk)
                    this.riskList = this.riskItems
                  })
                } else {
                  this.riskItems = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Hull') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalHullItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.riskItems = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      busCls: risk.busCls,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      vesNo: risk.vesNo,
                      vesName: risk.vesName
                    }
                    this.riskItems.push(convertRisk)
                    this.riskList = this.riskItems
                  })
                } else {
                  this.riskItems = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Medical') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalMedItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.riskItems = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      busCls: risk.busCls,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      icNo: risk.icNo
                    }
                    this.riskItems.push(convertRisk)
                    this.riskList = this.riskItems
                  })
                } else {
                  this.riskItems = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Personal Accident') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalPaItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.riskItems = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      busCls: risk.busCls,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      icNo: risk.icNo
                    }
                    this.riskItems.push(convertRisk)
                    this.riskList = this.riskItems
                  })
                } else {
                  this.riskItems = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Miscellaneous') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalMiscItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.riskItems = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      busCls: risk.busCls,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate)
                      // contrt: risk.contrt
                    }
                    this.riskItems.push(convertRisk)
                    this.riskList = this.riskItems
                  })
                } else {
                  this.riskItems = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Motor') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalMotorItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.riskItems = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      busCls: risk.busCls,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      vehRegNo: risk.vehRegNo,
                      engNo: risk.engNo,
                      chasNo: risk.chasNo,
                      trailerRegNo: risk.trailerRegNo,
                      ownName: risk.ownName
                    }
                    this.riskItems.push(convertRisk)
                    this.riskList = this.riskItems
                  })
                } else {
                  this.riskItems = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalAllClassItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.riskItems = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      busCls: risk.busCls,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate)
                    }
                    this.riskItems.push(convertRisk)
                    this.riskList = this.riskItems
                  })
                } else {
                  this.riskItems = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        }
      }
    },
    valMainClasses() {
      // if (this.filters.mainClasses === 'All Classes') {
      //   // this.activeTab = '1'
      //   this.showRisk = false
      //   this.showBusCls = false
      // } else {
      //   this.showVesNo = false
      //   this.showVesName = false
      //   this.showVoyNo = false
      //   this.showVoyDesc = false
      //   this.showRiskLoc = false
      //   this.showIcNo = false
      //   this.showContrt = false
      //   this.showMotor = false
      //   this.showBusCls = true
      //   if (this.filters.mainClasses === 'Cargo') {
      //     this.showVesNo = true
      //     this.showVesName = true
      //     this.showVoyNo = true
      //     this.showVoyDesc = true
      //   } else if (this.filters.mainClasses === 'Fire') {
      //     this.showRiskLoc = true
      //   } else if (this.filters.mainClasses === 'Hull') {
      //     this.showVesNo = true
      //     this.showVesName = true
      //   } else if (this.filters.mainClasses === 'Medical') {
      //     this.showIcNo = true
      //   } else if (this.filters.mainClasses === 'Miscellaneous') {
      //     this.showContrt = true
      //   } else if (this.filters.mainClasses === 'Motor') {
      //     this.showMotor = true
      //   } else if (this.filters.mainClasses === 'Personal Accident') {
      //     this.showIcNo = true
      //   }
      //   this.showRisk = true
      // }
      this.doAssignSelectorColumns()
      this.showVesNo = false
      this.showVesName = false
      this.showVoyNo = false
      this.showVoyDesc = false
      this.showRiskLoc = false
      this.showIcNo = false
      this.showContrt = false
      this.showMotor = false
      this.showBusCls = true
      if (this.filters.mainClasses === 'Cargo') {
        this.showVesNo = true
        this.showVesName = true
        this.showVoyNo = true
        this.showVoyDesc = true
      } else if (this.filters.mainClasses === 'Fire') {
        this.showRiskLoc = true
      } else if (this.filters.mainClasses === 'Hull') {
        this.showVesNo = true
        this.showVesName = true
      } else if (this.filters.mainClasses === 'Medical') {
        this.showIcNo = true
      } else if (this.filters.mainClasses === 'Miscellaneous') {
        this.showContrt = true
      } else if (this.filters.mainClasses === 'Motor') {
        this.showMotor = true
      } else if (this.filters.mainClasses === 'Personal Accident') {
        this.showIcNo = true
      }
      this.loadPolicy = false
      this.loadRisk = false
      this.fetchData(false)
    },
    doCreatePolicy() {
      this.$store.commit(POLICY_NEW_MODE)
      this.$router.push({ name: 'policyGeneral' })
    },
    canQuery(data) {
      return this.filters.review === 'policy' || this.filters.review === 'endorse' || this.filters.review === 'renew'
    },
    canCreate(data) {
      if (this.filters.review === 'endorse' || this.filters.review === 'renew') {
        if (this.filters.review === 'renew' && (data.item.renPolNo === '' || data.item.renPolNo === undefined) && data.item.tranRel === 'YES') {
          return true
        }
        if (this.filters.review === 'endorse' && data.item.tranRel === 'YES') {
          return true
        }
      }
      return false
    },
    canReview(data) {
      if (this.filters.review === 'policy' || this.filters.review === 'endorse' || this.filters.review === 'renew') {
        // if (data.item.tranRel === 'NO' || (data.item.tranRel === 'YES' && data.item.entRILater === 'YES')) {
        if (data.item.tranRel === 'NO') {
          return true
        }
      } else if (this.filters.review === 'endorse') {
      }
      return false
    },
    canCopy(data) {
      return this.filters.review === 'copy'
    },
    canAmend(data) {
      return this.filters.review === 'amend'
    },
    canRemove(data) {
      return this.filters.review === 'remove'
    },
    doQuery(data) {
      this.loading = true
      this.$store.dispatch('dispatchClear')
      this.$store.dispatch('reviewPolicy', data).then(() => {
        this.$router.push({ name: 'queryPolicy' })
        this.loading = false
      })
    },
    doReview(data) {
      this.loading = true
      // AR: OS-660 Added to check if record is locked 2021-01-29
      this.checkRecordLock(data.item.polNo, 'POL').then((result) => {
        // Record not locked proceed to review 2021-01-29
        if (!result) {
          if (data.item.tranType === 'C') {
            this.$store.commit(POLICY_CANCELLATION_MODE)
          } else if (data.item.tranType === 'E') {
            this.$store.commit(POLICY_ENDORSEMENT_MODE)
          } else {
            this.$store.commit(POLICY_REVIEW_MODE)
          }
          this.$store.dispatch('reviewPolicy', data).then(() => {
            this.$router.push({ name: 'policyGeneral' })
            this.loading = false
          })
          // Record was locked show message 2021-01-29
        } else {
          this.loading = false
        }
      })
    },
    doCreate(data) {
      this.policyData = data.item
      if (this.filters.review === 'endorse') {
        this.$refs.endorsePolicy.endorseForm.endorseType = null
        this.endorsePolicy = true
      } else if (this.filters.review === 'renew') {
        this.doRenewal()
      } else {
        this.$toast.success('doCreate')
      }
    },
    doCopy(data) {
      this.policyData = data.item
      // this.$refs.copyPolicy.doInit()
      this.copyPolicy = true
    },
    doAmend(data) {
      this.loading = true
      this.$store.commit(POLICY_REVIEW_MODE)
      this.$store.dispatch('reviewPolicy', data).then(() => {
        this.$router.push({ name: 'policyAmend' })
        this.loading = false
      })
    },
    doRemove(data) {
      this.loading = true
      this.$store.dispatch('reviewPolicy', data).then(() => {
        this.$router.push({ name: 'deleteUnreleasedPolicy' })
        this.loading = false
      })
    },
    doButtons(data) {
      this.filters.review = data
      this.loadRisk = false
      this.loadPolicy = false
      this.fetchData(false)
      if (data === 'policy') {
        this.listMode = 'Policy'
      } else if (data === 'endorse') {
        this.listMode = 'Endorsement'
      } else if (data === 'renew') {
        this.listMode = 'Renewal'
      } else if (data === 'copy') {
        this.listMode = 'Copy Policy'
      } else if (data === 'amend') {
        this.listMode = 'Amend Policy'
      } else if (data === 'remove') {
        this.listMode = 'Delete Policy'
      }
    },
    doClearFilters() {
      this.filters.mainClasses = this.params.mainClasses[0].value
      this.filters.polNo = null
      this.filters.moCmpNo = null
      this.filters.insdName1 = null
      this.filters.comDate = null
      this.filters.expDate = null
      this.filters.tranDate = null
      this.filters.insdRefNo = null
      this.filters.acctNo1 = null
      this.filters.cedPolNo = null
      this.filters.cedCesNo = null
      this.filters.brkSlipNo = null
      this.filters.brkTranRef = null
      this.filters.vesNo = null
      this.filters.vesName = null
      this.filters.voyNo = null
      this.filters.voyDesc = null
      this.filters.riskLoc = null
      this.filters.icNo = null
      // this.filters.contrt = null
      this.filters.vehRegNo = null
      this.filters.ownName = null
      this.filters.engNo = null
      this.filters.chasNo = null
      this.filters.trailerRegNo = null
      this.filters.riCo = null
      this.filters.polType = null
      this.filters.cnNo = null
      this.filters.busCls = null

      this.showVesNo = false
      this.showVesName = false
      this.showVoyNo = false
      this.showVoyDesc = false
      this.showRiskLoc = false
      this.showIcNo = true
      this.showContrt = false
      this.showMotor = false
      this.showBusCls = false

      this.loadRisk = false
      this.loadPolicy = false
      this.policyList = []
      this.riskList = []

      this.showRisk = false
      // this.showRiskTabs = false

      this.apiUrl = this.listState.policyListing
      this.showPolicyTabs = true
      this.tab = 0

      this.defaultFilter = {}
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      if (this.tab === 0) {
        this.loadPolicy = true
        this.loadRisk = false
      } else {
        this.loadPolicy = false
        this.loadRisk = true
      }
      // if (this.showRisk) {
      //   this.showRiskTabs = true
      // } else {
      //   this.showRiskTabs = false
      // }
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.paginationPolHeader.page = 1
          this.fetchData(false)
        }
      })
    },
    doRiskTabs() {
      this.showPolicyTabs = false
      if (!this.loadRisk) {
        this.riskItems = []
        this.loadRisk = true
        this.fetchData(false)
      } else {
        this.riskItems = this.riskList
      }
    },
    doPolicyTabs() {
      this.showPolicyTabs = true
      this.filters.busCls = null
      this.showBusCls = false
      if (!this.loadPolicy) {
        this.items = []
        this.loadPolicy = true
        if (this.initialLoad === false) {
          this.fetchData(false)
        }
      } else {
        this.items = this.policyList
      }
    },
    // doColumn(detailTab, columns) {
    //   this.columns = []
    //   if (detailTab === 'Policy Details') {
    //     this.apiUrl = this.listState.policyListing
    //     this.filters.busCls = null
    //     this.getDetTab = detailTab
    //     this.showBusCls = false
    //     this.doPolicyTabs()
    //   } else if (detailTab === 'Risk Details') {
    //     this.apiUrl = this.listState.policyRiskListing
    //     this.getDetTab = detailTab
    //     this.showBusCls = true
    //     this.doRiskTabs()
    //   }
    // },
    doColumn(detailTab) {
      this.getDetTab = detailTab
      if (detailTab === 'Policy Details') {
        this.apiUrl = this.listState.policyListing
        this.filters.busCls = null
        this.showBusCls = false
        this.doPolicyTabs()
      } else if (detailTab === 'Risk Details') {
        this.apiUrl = this.listState.policyRiskListing
        this.showBusCls = true
        this.doRiskTabs()
      }
      this.doAssignSelectorColumns()
    },
    doDisabledTab(detailTab) {
      return detailTab === 'Risk Details' && this.showRiskTabs === false
    },
    doCloseCopyPolicy() {
      this.copyPolicy = false
    },
    async doGetPolType() {
      const apiURI = this.listState.polTypeList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiURI))
          const data = result.data.polTypeList
          this.polTypeList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                value: datamap.value,
                label: datamap.label
              }
              this.polTypeList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCloseEndorsePolicy() {
      this.endorsePolicy = false
    },
    async doRenewal() {
      const apiUrl = this.listState.renewPolicy
      if (apiUrl) {
        try {
          this.processing = true
          const expand = {
            polNo: this.policyData.polNo,
            renCnt: this.policyData.renCnt,
            endtCnt: this.policyData.endtCnt,
            tranType: 'R',
            chkBalOSLoc: !this.acceptRenewPolicy
          }
          const result = await this.$http.post(expandURI(apiUrl, expand))
          if (result) {
            if (result.data.messages && result.data.messages.length > 0) {
              if (result.data.messages[0].type === 'WARN') {
                this.warnRenewPolicyMsg = result.data.messages[0].message
                this.warnRenewPolicy = true
              }
            } else {
              const item = {
                polNo: result.data.polNo,
                renCnt: result.data.renCnt,
                endtCnt: result.data.endtCnt
              }
              const data = {
                item: item
              }
              this.$store.commit(POLICY_RENEWAL_MODE)
              this.$store.dispatch('reviewPolicy', data).then(() => {
                this.$router.push({ name: 'policyGeneral' })
                this.processing = false
              })
            }
          }
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doAcceptRenewPolicy() {
      this.acceptRenewPolicy = true
      this.doRenewal()
    },
    doCancelRenewPolicy() {
      this.warnRenewPolicy = false
    },
    doAssignSelectorColumns() {
      if (this.getDetTab === 'Policy Details') {
        this.exportList.selectorColumns = this.policyColumns
      } else if (this.getDetTab === 'Risk Details') {
        if (this.filters.mainClasses === 'Cargo') {
          this.exportList.selectorColumns = this.polCargoRiskColumns
        } else if (this.filters.mainClasses === 'Fire') {
          this.exportList.selectorColumns = this.polFireRiskColumns
        } else if (this.filters.mainClasses === 'Hull') {
          this.exportList.selectorColumns = this.polHullRiskColumns
        } else if (this.filters.mainClasses === 'Miscellaneous') {
          this.exportList.selectorColumns = this.polMiscRiskColumns
        } else if (this.filters.mainClasses === 'Motor') {
          this.exportList.selectorColumns = this.polMotorRiskColumns
        } else {
          this.exportList.selectorColumns = this.allClassRiskColumns
        }
      }
    },
    checkFiltersNullValue() {
      const ignore = ['mainClasses', 'review']
      return Object.keys(this.filters)
        .filter(key => !ignore.includes(key))
        .every(key => this.filters[key] === null ||
          this.filters[key] === '' ||
          this.filters[key] === undefined
        )
    },
    doExportFilters() {
      const checknull = this.checkFiltersNullValue()
      if (checknull) {
        this.exportList.promptFilterWarning = true
      } else {
        this.exportList.promptFilterWarning = false
        this.exportList.cfmExportUwList = true
      }
    },
    async doExportList(columns, columnsTitle) {
      const apiUrl = this.listState.exportUwFilteredList
      if (apiUrl) {
        try {
          this.processing = true
          let massageForm = clone(this.filters)
          massageForm.columns = columns
          massageForm.columnsTitle = columnsTitle
          massageForm.mode = this.filters.review
          massageForm.detailTabs = this.getDetTab
          await this.$http.post(apiUrl, massageForm)
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCancelFilters() {
      this.filterPanels = []
    }
  },
  beforeMount() {
    this.$store.commit(POLICY_RESET)
  },
  created() {
    this.doInit()
    this.filters.mainClasses = this.params.mainClasses[0].value
    this.filters.review = 'policy'
    this.apiUrl = this.listState.policyListing
  },
  async mounted() {
    this.doGetPolType()
  },
  mixins: [listPolicyMixin, recordLockMixin, commonAjaxMixin],
  components: {
    CopyPolicy,
    EndorsePolicy,
    SearchFilter,
    UpdateSearchFilter
  },
  computed: {
    ...mapGetters(['checkAccess']),
    displayErrorDialog() {
      return this.messages
    }
  }
}
</script>

<style lang="scss">
@import '../../../../assets/scss/underwriting.scss';
</style>
